import { createContext } from 'react'

import { emptyDashboard } from './consts'

export const DashboardModalsContext = createContext({
  dashboard: emptyDashboard,
  setDashboard: _value => {},
  isCreateDashboardModalOpen: false,
  setIsCreateDashboardModalOpen: _value => {},
  isEditDashboardModalOpen: false,
  setIsEditDashboardModalOpen: _value => {},
  isDeleteDashboardModalOpen: false,
  setIsDeleteDashboardModalOpen: _value => {},
  createDashboardStep: 1,
  setCreateDashboardStep: _value => {},
  isCreateDashboardFolderOpen: false,
  setIsCreateDashboardFolderOpen: _value => {},
  folder: null,
  setFolder: _value => {},
  isDeleteDashboardFolderOpen: false,
  setIsDeleteDashboardFolderOpen: _value => {},
  isEditDashboardFolderOpen: false,
  setIsEditDashboardFolderOpen: _value => {},
  isSelectDashboardFolderModalOpen: false,
  setIsSelectDashboardFolderModalOpen: _value => {},
})
